import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { LIVE_ACTIVITY } from '../data/liveActivity';
import { EyeIcon } from './icons/CraftIcons';
export function LiveViewersBadge() {
  const [viewers, setViewers] = useState(LIVE_ACTIVITY.viewersBase);
  useEffect(() => {
    const id = window.setInterval(() => {
      setViewers(current => {
        const drift = Math.floor(Math.random() * 7) - 3;
        const next = current + drift;
        const min = LIVE_ACTIVITY.viewersBase - LIVE_ACTIVITY.viewersJitter;
        const max = LIVE_ACTIVITY.viewersBase + LIVE_ACTIVITY.viewersJitter;
        return Math.min(max, Math.max(min, next));
      });
    }, LIVE_ACTIVITY.viewersTickMs);
    return () => window.clearInterval(id);
  }, []);
  return <motion.div initial={{
    opacity: 0,
    y: -14,
    scale: 0.95
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={{
    type: 'spring',
    stiffness: 240,
    damping: 22,
    delay: 1.2
  }} className="fixed right-3 top-[84px] z-40 sm:right-5 sm:top-[60px]" aria-live="polite" data-id="element-264" data-mp="1xkrx9j5kqmxa">
      <div className="flex items-center gap-2.5 rounded-full border border-hairline bg-ink/90 py-2 pl-2.5 pr-4 shadow-lift backdrop-blur-sm" data-id="element-265" data-mp="1a35gkkijtt4i">
        <span className="relative flex h-6 w-6 items-center justify-center rounded-full bg-sage/25 text-sage-tint" data-id="element-266" data-mp="v5d2lwsnhcsf">
          <EyeIcon className="h-3.5 w-3.5" data-id="element-267" data-mp="103elohq2tc3w" />
          <span className="absolute -right-0.5 -top-0.5 flex h-2.5 w-2.5" data-id="element-268" data-mp="mdb4442566ks">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-sage opacity-70" data-id="element-269" data-mp="mbzzk20vgusm" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full border border-ink bg-sage" data-id="element-270" data-mp="cfx053xena9d" />
          </span>
        </span>

        <p className="text-[11px] font-semibold text-cream" data-id="element-271" data-mp="hft45363r1ox">
          <AnimatePresence mode="popLayout" initial={false} data-id="element-272" data-mp="3eyxaoypd8sd">
            <motion.span key={viewers} initial={{
            opacity: 0,
            y: -8
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.25
          }} className="mr-1 inline-block font-mono text-[12.5px] font-extrabold text-gold-light" data-id="element-273" data-mp="3fs3notr1w9z">
              {viewers}
            </motion.span>
          </AnimatePresence>
          makers viewing this page now
        </p>
      </div>
    </motion.div>;
}